import React from 'react'
import './styles.css'
import cn from 'classnames'
import Icon from 'components/icons'
import colors from '../../../styles/colors.css'
import {
  POSITION_STYLES
} from 'constants/visManager'

function LocalMediaOverlay(props) {
  const {
    camOff,
    micOff,
    position
  } = props

  return (
    <div styleName={cn('overlay', {camOff, micOff})} style={POSITION_STYLES[position]}>
      <div styleName='videoIconContainer'>
        <Icon name='cam-off' fill={colors.shade0} fillOpacity='0.65' />
      </div>
      <div styleName='micIconContainer'>
        <Icon name='mic-off' fill={colors.shade0} fillOpacity='0.65' />
      </div>
    </div>
  )
}

export default LocalMediaOverlay
